import React,{use, useEffect} from "react";

function Faq() {




const handleClick = (id) => {
  const element = document.getElementById(id);
  const isOpen = element?.classList.contains("show");

  // 1️⃣ Close all open panels
  const all = document.querySelectorAll(".collapse.show");
  all.forEach((el) => el.classList.remove("show"));

  // 2️⃣ Only open the clicked one if it was NOT already open
  if (element && !isOpen) {
    element.classList.add("show");
  }
};

  return (
    <>
      <section className="faq position-relative   ps pt-md-5" id="faq">
        <div className="container">
          <div className="d-sm-flex mb-md-5 justify-content-between">
            <h2 className="hadding  ">Frequently asked Questions</h2>
            <a href="#" className="op0_5">
              Read all FAQs
            </a>
          </div>
          <div id="accordion">
            <div className="card aos-init">
              <div className="card-header">
                <a className="collapsed" data-bs-toggle="collapse" onClick={()=>handleClick("collapseOne")} style={{cursor:"pointer"}}>
                  How does EPLIMO work?
                </a>
              </div>
              <div
                id="collapseOne"
                className="collapse"
                data-bs-parent="#accordion"
              >
                <div className="card-body">
                  EPLIMO analyzes your DNA to understand your genetic
                  predispositions. Based on this analysis, we provide
                  personalized recommendations on nutrition, exercise,
                  supplements, and other lifestyle factors to optimize your
                  health and well-being.
                </div>
              </div>
            </div>
            <div className="card aos-init">
              <div className="card-header">
                <a
                  className="collapsed "
                  data-bs-toggle="collapse"
                  onClick={()=>handleClick("collapseTwo")} style={{cursor:"pointer"}}
                  
                >
                  What is the process for getting started with EPLIMO?
                </a>
              </div>
              <div
                id="collapseTwo"
                className="collapse"
                data-bs-parent="#accordion"
              >
                <div className="card-body">
                  To get started, you will need to provide a DNA sample. This is
                  usually done through a simple saliva test. Once your sample is
                  collected, it is sent to our lab for analysis. After the
                  analysis, you will receive a comprehensive report with your
                  personalized recommendations.
                </div>
              </div>
            </div>
            <div className="card aos-init">
              <div className="card-header">
                <a
                  className="collapsed "
                  data-bs-toggle="collapse"
                  onClick={()=>handleClick("collapseThree")} style={{cursor:"pointer"}}
                >
                  Who can benefit from EPLIMO?
                </a>
              </div>
              <div
                id="collapseThree"
                className="collapse"
                data-bs-parent="#accordion"
              >
                <div className="card-body">
                  EPLIMO is beneficial for anyone looking to improve their
                  health and wellness. Whether you want to enhance your fitness,
                  manage your weight, prevent chronic diseases, or simply feel
                  better, EPLIMO can provide valuable insights and
                  recommendations.
                </div>
              </div>
            </div>
               <div className="card aos-init" >
              <div className="card-header">
                <a
                  className="collapsed "
                  data-bs-toggle="collapse"
                  onClick={()=>handleClick("collapseThree0")} style={{cursor:"pointer"}}
                >
              Can I use EPLIMO if I have a medical condition?
                </a>
              </div>
              <div
                id="collapseThree0"
                className="collapse"
                data-bs-parent="#accordion"
              >
                <div className="card-body">
                 Yes, you can use EPLIMO if you have a medical condition. However, it is important to consult with your healthcare provider before making any changes to your lifestyle or treatment plan based on the recommendations from EPLIMO.
                </div>
              </div>
            </div>
            <div className="card aos-init">
              <div className="card-header">
                <a
                  className="collapsed "
                  data-bs-toggle="collapse"
                  onClick={()=>handleClick("collapseThree1")} style={{cursor:"pointer"}}
                >
                  Is there any ongoing support after I receive my EPLIMO report?
                </a>
              </div>
              <div
                id="collapseThree1"
                className="collapse"
                data-bs-parent="#accordion"
              >
                <div className="card-body">
                  Yes, we provide ongoing support to help you implement and
                  follow the recommendations from your EPLIMO report. Our team
                  of experts is available to answer your questions and provide
                  guidance as needed.
                </div>
              </div>
            </div>
            <div className="card aos-init">
              <div className="card-header">
                <a
                  className="collapsed "
                  data-bs-toggle="collapse"
                  onClick={()=>handleClick("collapseThree2")} style={{cursor:"pointer"}}
                >
                  How can I purchase EPLIMO?
                </a>
              </div>
              <div
                id="collapseThree2"
                className="collapse"
                data-bs-parent="#accordion"
              >
                <div className="card-body">
                  Book a free consultation and our genetic counsellor will guide
                  you through the process.
                </div>
              </div>
            </div>
            <div className="card aos-init">
              <div className="card-header">
                <a
                  className="collapsed "
                  data-bs-toggle="collapse"
                  onClick={()=>handleClick("collapseThree21")} style={{cursor:"pointer"}}
                >
                  How long does it take to receive my EPLIMO report?
                </a>
              </div>
              <div
                id="collapseThree21"
                className="collapse"
                data-bs-parent="#accordion"
              >
                <div className="card-body">
                  Once your DNA sample is received by our lab, it typically
                  takes 4-6 weeks to complete the analysis and generate your
                  report. You will be notified as soon as your report is ready.
                </div>
              </div>
            </div>
            <div className="card aos-init">
              <div className="card-header">
                <a
                  className="collapsed "
                  data-bs-toggle="collapse"
                 onClick={()=>handleClick("collapseThree224")} style={{cursor:"pointer"}}
                >
                  Can I share my EPLIMO report with my doctor?
                </a>
              </div>
              <div
                id="collapseThree224"
                className="collapse"
                data-bs-parent="#accordion"
              >
                <div className="card-body">
                  Yes, you are encouraged to share your EPLIMO report with your
                  healthcare provider. The insights and recommendations in the
                  report can be valuable for your overall health management and
                  care.
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}

export default Faq;
